import { render, staticRenderFns } from "./UserAssetDetail.vue?vue&type=template&id=f4ab2822"
import script from "./UserAssetDetail.vue?vue&type=script&lang=js"
export * from "./UserAssetDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports